module.exports = __webpack_public_path__ + "static/media/logo-header.615d7b05.svg";